import { baseAPI } from "../../baseApi";
import { tagsTypes } from "../../tagsTypes";

export const dashboardSlice = baseAPI.injectEndpoints({
  endpoints: (builder) => ({
    getDashboardListing: builder.query({
      query: () => ({
        url: `dashboard-content`,
        method: "GET",
      }),
      providesTags: [tagsTypes?.GET_DASHBOARD_CONTENT],
    }),
    getOrderDetails: builder.query({
      query: (id) => ({
        url: `orders-detail/${id}`,
        method: "GET",
      }),
      keepUnusedDataFor: 0,
      
    }),
  }),
});

export const { useGetDashboardListingQuery, useGetOrderDetailsQuery } =
  dashboardSlice;
